export default __webpack_public_path__ + "static/media/um2.45402ff1.svg";